import React from 'react'

const Index = () =><div className="spinner-outer">
        <div className='spinner'></div>
     </div> 

export default Index
